// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { filterStyles } from "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListFilter";
import myAccountFilterSectionStyles from "@keller/App/SharedStyle/MyAccount/List/MyAccountFilterSectionStyles";
import { mergeWithCss, xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

filterStyles.container = {
    ...mergeWithCss(myAccountFilterSectionStyles.searchFormStyles.wrapper, {
        css: css`
            padding: 20px 30px;
        `,
    }),
};

filterStyles.heading = {
    ...myAccountFilterSectionStyles.searchFormStyles.headingText,
};

filterStyles.shipToGridItem = {
    width: [12, 12, 6, 5, 4],
};

filterStyles.orderNumberGridItem = {
    width: [12, 12, 6, 3, 2],
};

filterStyles.datesGridItem = {
    width: [12, 12, 12, 4, 6],
};

filterStyles.datesContainer = {
    gap: 20,
};

filterStyles.dateRangeFieldset = {
    css: css`
        border: none;
        margin: 0;
        padding: 0;
        width: 100%;
    `,
};

filterStyles.fromGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        > div {
            display: flex;
            width: 100%;
        }
    `,
};

filterStyles.toGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        > div {
            display: flex;
            width: 100%;
        }
    `,
};

filterStyles.clearFiltersButton = {
    variant: "secondary",
};

filterStyles.toDate = {
    cssOverrides: {
        inputSelect: css`
            width: 100%;
        `,
    },
};

filterStyles.orderTotalGridItem = {
    width: [12, 12, 12, 10, 12],
};

filterStyles.orderTotalContainer = {
    gap: 20,
};

filterStyles.orderTotalOperatorGridItem = {
    width: [12, 6, 3, 3, 2],
};

filterStyles.orderTotalAmountGridItem = {
    width: [12, 6, 3, 3, 2],
};

filterStyles.orderTotalAmountTextField = {
    cssOverrides: {
        formInputWrapper: css`
            margin-top: 21px;
            padding-right: 10px;

            ${xScreen("lte", "sm")} {
                padding-left: 3px;
                padding-right: 0;
            }
        `,
    },
    label: translate("Amount"),
} as any;
